/** @format */

const userDustLogs = {
  // user 页曝光
  userPageShowLog: {
    event: 'page_show',
    params: {
      page: 'user',
    },
  },
};

export default userDustLogs;
